export default __webpack_public_path__ + "static/media/slide_3.198d9ec7.jpg";